import React from 'react'
import "./style.css"

const Header = () => {
  return (
    <div className='home-header'>
        <h2>
            Foresight Placements
        </h2>
        <h1>
            <span>
                </span> Blogs <span>
            </span>
        </h1>
        <p>
            Know everything about your placement in final year<br/>
        </p>
    </div>
  )
}

export default Header
